import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useSWR from "swr";
import errorSign from "../../assets/images/warning-hex-svgrepo-com.svg";

const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || "http://localhost:3001";
const fetcher = (url) => axios.get(url).then((res) => res.data);

const PaymentStatus = () => {
  const { internalId } = useParams();
  const [merchantDetails, setMerchantDetails] = useState(null);
  const [shouldPoll, setShouldPoll] = useState(true);
  const [pollingInterval, setPollingInterval] = useState(5000);
  // const [loadingMessage, setLoadingMessage] = useState('Initiating payment...')

  const { data, error } = useSWR(
    `${BACKEND_URL}/api/paymentLinks/paymentStatus?internalID=${internalId}`,
    fetcher,
    {
      refreshInterval: pollingInterval,
      onSuccess: (response) => {
        if (response.success) {
          if (
            response.data.status === "SUCCESS" ||
            response.data.status === "FAILED"
          ) {
            setPollingInterval(null); // Stop polling when we have a final status
            setShouldPoll(false);
            fetchMerchantDetails(response.data.linkName);
          }
        } else {
          // Handle unsuccessful response
          console.error("Unsuccessful response:", response.message);
          setPollingInterval(null);
          setShouldPoll(false);
        }
      },
      onError: (error) => {
        console.error("Fetching error:", error);
        setPollingInterval(null); // Stop polling on error
        setShouldPoll(false);
      },
    }
  );

  const fetchMerchantDetails = async (linkName) => {
    try {
      const response = await axios.get(
        `${BACKEND_URL}/api/paymentLinks/link/${linkName}`
      );
      setMerchantDetails(response.data);
      console.log(merchantDetails);
    } catch (error) {
      console.error("Error fetching merchant details:", error);
    }
  };

  const startPolling = () => {
    setShouldPoll(true);
    setPollingInterval(5000);
  };

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  if (error)
    return (
      <div className="max-w-6xl m-4 md:mx-auto flex flex-col items-center min-h-[500px]">
        <div>Error occurred while fetching payment status: {error.message}</div>
        <button onClick={startPolling}>Retry</button>
      </div>
    );

  if (data?.data.status === "PENDING" || data?.data.status === "PROCESSING")
    return (
      <div className="max-w-6xl m-4 md:mx-auto flex flex-col items-center min-h-[500px]">
        <div className="flex items-center gap-2" role="status">
          <svg
            aria-hidden="true"
            class="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="#4E1C4E"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="#e9b22c"
            />
          </svg>
          <p>Processing payment.....</p>
        </div>
      </div>
    );

  if (!data?.success)
    return (
      <div>
        <div>Error: {data?.message}</div>
        <button onClick={startPolling}>Retry</button>
      </div>
    );

  const paymentData = data.data;

  return (
    <div className="max-w-6xl m-4 md:mx-auto flex flex-col items-center min-h-[500px]">
      {paymentData.status === "SUCCESS" && (
        <div>
          <div className="text-center mb-7">
            <h1 className="text-5xl font-bold text-[#4e1c4e]">Thank You!</h1>
            <p className="max-w-[300px] text-[#4e1c4e] mx-auto">
              {merchantDetails?.data.fullName} is grateful for your
              Gift!
            </p>
          </div>
          <div className="max-w-[400px] p-4  border-1 shadow-xl rounded-lg border border-gray-200">
            <div className="feedback-card w-full">
              <p className="font-bold">
                Please leave a comment to appreciate{" "}
                {merchantDetails?.data.fullName}'s work!
              </p>
              <p className="mb-4">
                "Your kind words help to propel my creativity."
              </p>
              <textarea
                className="border rounded-xl w-full h-[100px] py-2 px-3 focus:outline-none focus:ring-2 focus:ring-[#e9b22c] mb-2"
                name="comment"
                id="comment"
                placeholder="Leave a comment..."
              ></textarea>
              <div className="flex flex-col gap-2">
                <Link
                 to={`/pay/${paymentData.linkName}`}
                 className="bg-[#e9b22c] rounded-md py-1.5 text-gray-50 text-center">
                  Submit
                  </Link>

                <Link
                  to={"/"}
                  className="border border-gray-400 rounded-md py-1.5 bg-gray-50 text-center"
                >
                  Back to Home page
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
      {paymentData.status === "FAILED" && (
        <div className="flex flex-col justify-center items-center p-4 gap-2 max-w-[400px] shadow-xl border border-gray-200 rounded-lg text-[#4e1c4e]">
          <img className="w-16" src={errorSign} alt="" srcset="" />
          <h1 className="text-2xl font-bold">Payment Failed</h1>
          <p className="text-center">
            Please double-check your details and try again.
          </p>
          <p>{paymentData.externalStatus}</p>
          <Link
            className="bg-[#4e1c4e] text-gray-50 py-1.5 font-medium text-center rounded-lg w-full"
            to={`/pay/${paymentData.linkName}`}
          >
            Try Again
          </Link>
        </div>
      )}
    </div>
  );
};

export default PaymentStatus;
